import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import { log } from '@common/log/log'
import { PageSpinner } from '~/components/PageSpinner'
import { setAccessToken } from '~/data/accessToken'

/**
 * SAML callback page that receives the access token from the backend
 * after successful SAML authentication.
 */
function SamlCallbackPage() {
  const router = useRouter()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function handleCallback() {
      const token = router.query.token as string | undefined
      const errorParam = router.query.error as string | undefined

      if (errorParam) {
        log.warn('SAML callback error', { error: errorParam })
        await router.push({
          pathname: '/',
          query: { error: errorParam },
        })
        return
      }

      if (!token) {
        if (router.isReady) {
          log.warn('SAML callback: No token received')
          await router.push({
            pathname: '/',
            query: { error: 'SAML authentication failed. Please try again.' },
          })
        }
        return
      }

      try {
        setAccessToken(token)
        log.info('SAML callback: Token stored successfully')
        await router.push({ pathname: '/' })
      } catch (err) {
        log.error('SAML callback: Failed to process token', err)
        setError('Failed to complete authentication')
        await router.push({
          pathname: '/',
          query: { error: 'An error occurred during authentication. Please try again.' },
        })
      }
    }

    if (router.isReady) {
      void handleCallback()
    }
  }, [router, router.isReady, router.query])

  if (error) {
    return null
  }

  return <PageSpinner />
}

export default SamlCallbackPage
